<template>
  <!--<component class="wrapper" :is="currentView" transition-mode="out-in" :userToBeTransfered="userToBeTransfered"-->
  <!--@transitionend.stop @continue="next"/>-->
  <out-of-order />
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import InitLoader from "@/components/partials/InitLoader";
import TransferConfirm from "./Confirm";
import TransferSuccess from "./Success";
import OutOfOrder from "./OutOfOrder";

export default {
  name: "form-transfer",
  components: { InitLoader, TransferConfirm, TransferSuccess, OutOfOrder },
  data: function() {
    return {
      currentStep: 0,
      steps: ["InitLoader", "TransferConfirm", "TransferSuccess"]
    };
  },
  watch: {
    userToBeTransfered: "next"
  },
  computed: {
    ...mapGetters("user", {
      userToBeTransfered: "getUserToBeTransfered"
    }),
    currentView() {
      return this.steps[this.currentStep];
    }
  },
  methods: {
    ...mapActions("user", {
      getAccountToBeTransfered: "getAccountToBeTransfered"
    }),
    next() {
      this.currentStep += 1;
    }
  },
  mounted: function() {
    // this.getAccountToBeTransfered(this.$route.params.id);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  width: 100%;
  max-width: 480px;
}
</style>
